import { getRetailerState } from "./selectors";
import { MaybeEmpty, PartialPick } from "../../../../../constants";
import { EsimType, RootState } from "../../../../../models";
import { Customer, LegalOwnerIndividual } from "../../../../../models/state";

export type State = PartialPick<RootState, "retailer">;

export const getCustomerInfo = (state: State): MaybeEmpty<Customer["info"]> =>
    getRetailerState(state)?.customer?.info || {};

export const isSecretNumber = (state: State): boolean => !!getCustomerInfo(state).isSecretNumber;
export const isCatalogListingOk = (state: State): boolean => !!getCustomerInfo(state).isCatalogListingOk;
export const isNotFound = (state: State): boolean => !!getCustomerInfo(state).isNotFound;
export const isZipNeeded = (state: State): boolean => !!getCustomerInfo(state).isZipNeeded;
export const isProductUserDifferentThanLegalOwner = (state: State): boolean =>
    !!getCustomerInfo(state).isProductUserDifferentThanLegalOwner;
export const isOptingOutForTeliaXServices = (state: State): boolean =>
    !!getCustomerInfo(state).isOptingOutForTeliaXServices;
export const isEmailTakenForTeliaTrygg = (state: State): boolean => !!getCustomerInfo(state).isEmailTakenForTeliaTrygg;
export const isEmailTakenForTeliaSky = (state: State): boolean => !!getCustomerInfo(state).isEmailTakenForTeliaSky;
export const isCampaignToggled = (state: State): boolean => !!getCustomerInfo(state).isCampaignToggled;
export const isCampaignAllowed = (state: State): boolean => !!getCustomerInfo(state).isCampaignAllowed;
export const isProductUserAgeOk = (state: State): boolean => !!getCustomerInfo(state).isProductUserAgeOk;
export const isEsimSelected = (state: State): boolean => !!getCustomerInfo(state).isEsimSelected;
export const isKeepCurrentSim = (state: State): boolean => !!getCustomerInfo(state).isKeepCurrentSim;
export const isPhysicalSimSelected = (state: State): boolean => !!getCustomerInfo(state).isPhysicalSimSelected;
export const isSimFromStoreSelected = (state: State): boolean => !!getCustomerInfo(state).isSimFromStoreSelected;
export const storeSimNumber = (state: State): string => getCustomerInfo(state).storeSimNumber || "";
export const eid = (state: State): string => getCustomerInfo(state).eid || "";
export const esimType = (state: State): EsimType => getCustomerInfo(state).esimType || "";
export const getLegalOwner = (state: State): Partial<LegalOwnerIndividual> => getCustomerInfo(state).legalOwner || {};
export const getLegalOwnerBirthdate = (state: State): string => getLegalOwner(state).birthDate || "";
export const isBarringsUsed = (state: State): boolean => !!getCustomerInfo(state).isBarringsUsed;
